import Icon from '../ui/Icon';

// Botones de icono para editar/eliminar (anular) una aplicación. Área
// clickeable mínima 44x44px con foco visible; el llamador es responsable de
// hacer stopPropagation cuando la fila/tarjeta completa también es
// clickeable (para abrir el detalle).
function AplicacionRowActions({ onEdit, onEliminar }) {
  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={onEdit}
        aria-label="Editar aplicación"
        title="Editar"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-400"
      >
        <Icon name="edit" className="h-5 w-5" />
      </button>
      <button
        type="button"
        onClick={onEliminar}
        aria-label="Eliminar aplicación"
        title="Eliminar"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-red-50 hover:text-red-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-400"
      >
        <Icon name="trash" className="h-5 w-5" />
      </button>
    </div>
  );
}

export default AplicacionRowActions;
